import { useEffect, useState } from "react";
import { FileText, Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import api, { formatErr } from "@/lib/api";
import { toast } from "sonner";

const STATUS = { paid: ["Réglée", "bg-emerald-50 text-emerald-700"], pending: ["Prélèvement en cours", "bg-amber-50 text-amber-700"] };

export const InvoicesList = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/invoices").then((r) => setData(r.data)).catch(() => setData({ invoices: [] }));
  }, []);

  const download = async (inv) => {
    try {
      const res = await api.get(`/invoices/${inv.invoice_id}/pdf`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `facture-${inv.number}.pdf`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      toast.error(formatErr(e?.response?.data?.detail) || e.message);
    }
  };

  if (!data) return null;
  return (
    <div className="bg-white border border-slate-200 rounded-2xl p-6" data-testid="invoices-card">
      <div className="flex items-center gap-2 mb-4">
        <FileText className="h-5 w-5 text-[#618DB8]" />
        <h3 className="font-display font-extrabold text-deep">Mes factures</h3>
        <span className="text-xs text-slate-400 ml-auto">HT + TVA 20 % · PDF pour votre comptable</span>
      </div>
      {data.invoices.length === 0 ? (
        <p className="text-sm text-slate-500" data-testid="invoices-empty">
          Aucune facture pour le moment.
          {data.next_invoice_date && <> Votre première facture sera émise le <b>{new Date(data.next_invoice_date).toLocaleDateString("fr-FR", { dateStyle: "long" })}</b>, à la fin de votre essai gratuit.</>}
        </p>
      ) : (
        <div className="divide-y divide-slate-100">
          {data.invoices.map((inv) => (
            <div key={inv.invoice_id} className="py-3 flex flex-wrap items-center gap-3" data-testid={`invoice-row-${inv.number}`}>
              <div className="flex-1 min-w-[200px]">
                <div className="font-semibold text-sm text-deep font-mono">{inv.number}</div>
                <div className="text-xs text-slate-500">
                  {inv.plan === "premium" ? "Premium" : "Standard"} · du {new Date(inv.period_start).toLocaleDateString("fr-FR")} au {new Date(inv.period_end).toLocaleDateString("fr-FR")}
                </div>
              </div>
              <div className="text-right">
                <div className="font-bold text-sm">{inv.amount_ttc.toFixed(2).replace(".", ",")} € TTC</div>
                <div className="text-xs text-slate-400">{inv.amount_ht.toFixed(2).replace(".", ",")} € HT + {inv.vat.toFixed(2).replace(".", ",")} € TVA</div>
              </div>
              <span className={`text-[11px] font-bold px-2 py-0.5 rounded-full ${(STATUS[inv.status] || STATUS.pending)[1]}`}>{(STATUS[inv.status] || STATUS.pending)[0]}</span>
              <Button size="sm" variant="outline" onClick={() => download(inv)} data-testid={`invoice-download-${inv.number}`}>
                <Download className="h-3.5 w-3.5 mr-1.5" />PDF
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
